/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeviceModelApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  //save model firmware data
  saveDeviceModel(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'deviceModel/saveDeviceModel',
      Payload
    );
  }
  //update mode
  updateDeviceModelData(modelId, Payload): Observable<any> {
    return this.http.put(
      this.APIService + 'deviceModel/updateDeviceModel?modelId=' + modelId,
      Payload
    );
  }
  //Model prepopulation
  getDeviceModelDataById(modelId): Observable<any> {
    return this.http.get(
      this.APIService + 'deviceModel/getDeviceModelByModelId?modelId=' + modelId
    );
  }
  //get all model list
  getDeviceModelList(page, size, search): Observable<any> {
    return this.http.get(
      this.APIService +
        'deviceModel/getAllDeviceModelList?page=' +
        page +
        '&size=' +
        size +
        '&search=' +
        search
    );
  }
  deleteDeviceModelById(modelId, userId): Observable<any> {
    return this.http.delete(
      `${this.APIService}deviceModel/deleteDeviceModelByModelId?modelId=${modelId}&userId=${userId}`
    );
  }
}
